import styled from 'styled-components';

export const FeeDeleteButtonContainer = styled.div`
    & button {
        position: relative;
        top: 1.75rem;
    }
`;
